// import node module libraries
import React, { Fragment } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// import custom components
import NavbarHaeppyapp from 'layouts/marketing/navbars/NavbarHaeppyapp';
import FooterHaeppyappWithLinks from 'layouts/marketing/footers/FooterHaeppyappWithLinks';

import SEO from 'components/marketing/seo/Seo';

function Imprint() {
	return (
		<Fragment>
			<SEO
				title="Impressum – haeppy.app SaaS"
				noindex={true}
			/>
			<NavbarHaeppyapp
				transparent={false}
				center={false}
			/>
			<main>
				{/* pageheader */}
				<section className="py-10 bg-white">
					<Container>
						<Row className="justify-content-center">
							<Col lg={8} md={12} sm={12}>
								{/* text center */}
								<div className="text-center">
									<h1 className="display-3 fw-bold">Impressum</h1>
									<p className="lead px-8">
										Angaben gem. §5 Abs. 1 DDG
									</p>
								</div>
							</Col>
						</Row>
					</Container>
				</section>

				{/* content */}
				<section className="pb-10 bg-white">
					<Container>
						<Row className="justify-content-center">
							<Col lg={8} md={12} sm={12}>
								{/* heading */}
								<h1 className="fw-bold mb-3">
									KM Holding UG (haftungsbeschränkt)
								</h1>

								<p className="mb-1 fs-4">
									<span className="text-dark fw-semi-bold">Adresse: </span>Kopernikusstraße 14
									30167 Hannover
								</p>

								<p className="mb-1 fs-4">
									<span className="text-dark fw-semi-bold">Mail: </span>
									hallo@die-webarchitekten.de
								</p>

								<p className="mb-1 fs-4">
									<span className="text-dark fw-semi-bold">Telefon: </span>
									+49 (511) 51544703
								</p>

								<div className="d-flex mt-5">
									<div className="">
										<h3 className="fw-bold"></h3>
									</div>
									<div className="ms-3">
										<h3 className="fw-bold">
											Handelsregister
										</h3>
										<p className="fs-4">
											HRB 222914
										</p>
									</div>
								</div>
								{/* para */}
								<div className="d-flex mt-3">
									<div className="">
										<h3 className="fw-bold"></h3>
									</div>
									<div className="ms-3">
										<h3 className="fw-bold">
											Registergericht
										</h3>
										<p className="fs-4">
											Amtsgericht Hannover
										</p>
									</div>
								</div>
								{/* para */}
								<div className="mt-5">
									<h2 className="fw-bold">
										Vertreten durch
									</h2>
									<div className="d-flex mt-3">
										<div className="">
											<h3 className="fw-bold"></h3>
										</div>
										<div className="ms-3">
											<h3 className="fw-bold">
												Krzysztof Mistak
											</h3>
											<p className="fs-4">
												Geschäftsführer
											</p>
										</div>
									</div>

								</div>
								{/* para */}
								<div className="mt-5">
									<h2 className="fw-bold">
										Umsatzsteuer-ID
									</h2>
									{/* list */}
									<ul className="fs-4">
										<li>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE351422411</li>
										<li>Steuernummer: 25/204/04390 </li>
									</ul>
								</div>
								{/* para */}
								<div className="mt-5">
									<h2 className="fw-bold">
										Verbraucher­streit­beilegung/Universal­schlichtungs­stelle
									</h2>
									<p className="fs-4">
										Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
									</p>
									<h2 className="fw-bold">Allgemeine Geschäftsbedingungen (AGB)</h2>
									<p className="fs-4">
										Die aktuell gültigen und allgemeinen Geschäftsbedingungen können Sie hier einsehen:{' '}
										<Link to="/marketing/about/terms-and-conditions">AGB</Link>
									</p>
									<p className="fs-4">
										Bereits registrierte Benutzer erhalten von uns eine schriftliche Benachrichtigung, sobald sich die allgemeinen Geschäftsbedingungen ändern und deren Zustimmung erforderlich ist.
									</p>
								</div>
							</Col>
						</Row>
					</Container>
				</section>
			</main>
		</Fragment>
	);
}

export default Imprint;
